import { ReactElement } from 'react';

export function Information(): ReactElement | null {
  return null;
}
